module.exports = __webpack_public_path__ + "static/media/mapnode-biken.8dad303f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/assets/mapnode-biken.svg
// module id = 305
// module chunks = 0